<template>

    <div class="panel">
        <div class="panel__header">
            <h2>
                <i class="panel__header__icon icons icon-tag"></i>
                <span>{{$t('document_template.standard_tags')}}</span>
            </h2>
        </div>
        <div class="panel__body">
            <div v-if="loading">
                <div class="spinner"></div>
            </div>
            <div v-else-if="!tags.length" class="panel--empty">
                <center>{{$t('document_template.standard_tags_empty')}}</center>
            </div>
            <ul v-else class="tags">
                <li v-for="tag in tags">
                    <a class="tags__tag" @click.prevent="insertTag(tag)">
                        <code v-tooltip.right="tag.description">
                            {{tag.name}}
                        </code>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import {GET_DOCUMENT_TEMPLATES_TAGS} from '@/store/modules/document-template-tags';

    @Component
    export default class StandardTags extends Vue {
        loading = true;
        get tags() {
            return this.$store.state.document_template_tags.tags;
        }

        created() {
            this.loading = true;
            this.$store.dispatch(GET_DOCUMENT_TEMPLATES_TAGS, {}).finally(() => {
                this.loading = false;
            });
        }

        insertTag(tag) {
            this.$emit('insert', tag);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/panels/document-templates/StandardTags.vue